import { useState } from "react";
import styles from "./MS2C2_GenerateSinglePreviewFromEditState.module.css";

const GeneratePreviewFromEditState = ({ state, id }) => {
  console.log("Generating Preview");
  console.log(state);
  const { imageRight, imageLeft } = state;

  const [imageRightStyle, setImageRightStyle] = useState({
    width: "426px",
    height: "284px",
    objectFit: "cover",
  });

  const [imageLeftStyle, setImageLeftStyle] = useState({
    width: "426px",
    height: "284px",
    objectFit: "cover",
  });
  const checkAspectRatio = (event, setMethod) => {
    const image = event.target;
    if (image.naturalWidth > image.naturalHeight) {
      setMethod({ width: "426px", height: "284px", objectFit: "cover" });
    } else {
      setMethod({ width: "284px", height: "426px", objectFit: "cover" });
    }
  };
  return (
    <div className={styles.image_section_main} id={id}>
      <div className={`${styles.image_section_single_main} `}>
        <div className={styles.image_section_single_image}>
          <img
            src={imageLeft}
            onLoad={(event) => checkAspectRatio(event, setImageLeftStyle)}
            style={imageLeftStyle}
            alt="l-img"
            crossOrigin="anonymous"
          />
        </div>
      </div>

      <div className={`${styles.image_section_single_main} ${styles.ss1}`}>
        <div className={styles.image_section_single_image}>
          <img
            src={imageRight}
            onLoad={(event) => checkAspectRatio(event, setImageRightStyle)}
            style={imageRightStyle}
            alt="r-img"
            crossOrigin="anonymous"
          />
        </div>
      </div>
    </div>
  );
};
export default GeneratePreviewFromEditState;
